import React, {useEffect, useState} from 'react';
import {
  useRouteMatch
} from "react-router-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import 'firebase/compat/analytics';
import {init} from '../utils/initFirebase'
import '../styles/updates.css';
import ReactMarkdown from 'react-markdown'
import {useHistory} from "react-router-dom";

init();

const UpdateDetails = (props) => {
  const [content, setContent] = useState([]);
  let match = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    firebase.storage().ref("updates").child(`${match.params.newsUrl}.md`).getDownloadURL().then(url => {
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'text';
      xhr.onload = function(event) {
        var markdownData= xhr.response;
        setContent(markdownData);
      };
      xhr.open('GET', url);
      xhr.send();
    })
    .catch(err => {
      console.log(match);
      history.push(match.url.replace(match.params.newsUrl, ''));
    })
  }, [match.params.newsUrl]);


  return (
    <div className='updateDetailContainer'>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
  
}

export default UpdateDetails;